import { useTheme } from "@/theme";
import { AppLogoDark } from "./app-logo-dark";
import { AppLogoLight } from "./app-logo-light";

function AppLogo({
  width = 36,
  height = 36,
}: {
  width?: number;
  height?: number;
}) {
  const { theme } = useTheme();

  if (theme === "dark") {
    return <AppLogoDark width={width} height={height} />;
  }
  return <AppLogoLight width={width} height={height} />;
}

export default AppLogo;
